import { Store } from 'lucide-react';
import { winkelKleur } from '../winkelMerk.js';

/** Klein label met de winkelnaam in de merkkleur ("IXINA Lochristi" blauw, "VDBK Oostakker" rood). */
export function WinkelLabel({ naam, kleur, className = '' }: { naam: string; kleur?: string | null; className?: string }) {
  const c = kleur || winkelKleur(naam);
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full text-white whitespace-nowrap ${className}`} style={{ backgroundColor: c }} title={naam}>
      <Store size={11} /> {naam}
    </span>
  );
}
